import { render, staticRenderFns } from "./ShipmentContents.vue?vue&type=template&id=06890e0f&scoped=true&"
import script from "./ShipmentContents.vue?vue&type=script&lang=js&"
export * from "./ShipmentContents.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentContents.vue?vue&type=style&index=0&id=06890e0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06890e0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06890e0f')) {
      api.createRecord('06890e0f', component.options)
    } else {
      api.reload('06890e0f', component.options)
    }
    module.hot.accept("./ShipmentContents.vue?vue&type=template&id=06890e0f&scoped=true&", function () {
      api.rerender('06890e0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ShipmentContents.vue"
export default component.exports